<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue'
    import { Fachbereich, KennzahlStudiengang } from '@/js/model'

    import {
        useDashboardDataStore,
        useFachbereichStore,
        useKennzahlStudiengangStore,
        useStudiengangStore,
        useUserStore,
        useTooltipStore
    } from '@/js/stores'
    import FachbereichFilter from "@/js/components/Common/FachbereichFilter.vue";
    import KennzahlStudiengangFilter from "@/js/components/Common/KennzahlStudiengangFilter.vue";
    import YearFilter from "@/js/components/Common/YearFilter.vue";

    const isLoading = ref(false)
    const selectedFachbereich = ref<Fachbereich | null>(null)
    const selectedKennzahlStudiengang = ref<KennzahlStudiengang | null>(null)
    const selectedYear = ref<number>(6)

    const handleFachbereichSelected = (fachbereich: Fachbereich | null) => {
        selectedFachbereich.value = fachbereich
    }
    const handleKennzahlStudiengangSelected = (kennzahlStudiengang: KennzahlStudiengang | null) => {
        selectedKennzahlStudiengang.value = kennzahlStudiengang
        if (kennzahlStudiengang?.kennzahlStudiengangId) {
            dashboardDataStore.fetchDashboardDataByKennzahlStudiengangId(kennzahlStudiengang.kennzahlStudiengangId)
        }
    }
    const handleYearSelected = (year: number) => {
        selectedYear.value = year
    }

    const dashboardData = computed(() => {
        if (!selectedFachbereich.value || !selectedKennzahlStudiengang.value) {
            return []
        }

        return dashboardDataStore.getDashboardDataByKennzahlStudiengangId(
            selectedKennzahlStudiengang.value.kennzahlStudiengangId
        )
    })

    const dashboardDataStore = useDashboardDataStore()
    const userStore = useUserStore()
    const tooltipStore = useTooltipStore()
    const fachbereichStore = useFachbereichStore()
    const studiengangStore = useStudiengangStore()
    const kennzahlStudiengangStore = useKennzahlStudiengangStore()

    onMounted(async () => {
        isLoading.value = true
        await Promise.all([
            store.dispatch('user/findAll'),
            fachbereichStore.fetchFachbereiche(),
            studiengangStore.fetchStudiengaenge(),
            kennzahlStudiengangStore.fetchKennzahlStudiengaenge(),
            userStore.fetchUsers(),
            tooltipStore.fetchTooltips()
        ])
        isLoading.value = false
    })
</script>

<template>
    <v-row>
        <v-col class="border-b border-primary d-flex flex-row justify-start">
            <FachbereichFilter v-if="fachbereichStore.fachbereiche.length && studiengangStore.studiengaenge.length" @fachbereich-selected="handleFachbereichSelected" />
            <KennzahlStudiengangFilter v-if="kennzahlStudiengangStore.kennzahlStudiengaenge.length" :selected-fachbereich="selectedFachbereich" @kennzahl-studiengang-selected="handleKennzahlStudiengangSelected" />
            <YearFilter @year-selected="handleYearSelected" class="ml-auto" />
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="mt-0 pt-0">
            <DashboardDashboardZiel1
                :dashboardData="dashboardData"
                :years-to-display="selectedYear"
            />
            <DashboardDashboardZiel2
                :dashboardData="dashboardData"
                :years-to-display="selectedYear"
            />
            <DashboardDashboardZiel3
                :dashboardData="dashboardData"
                :years-to-display="selectedYear"
            />
            <DashboardDashboardZiel4
                :dashboardData="dashboardData"
                :years-to-display="selectedYear"
            />
        </v-col>
    </v-row>
</template>

<script></script>

<style scoped></style>
